var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _line, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTastePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 183,
    viewBox: "0 0 283 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 87,
    r: 6,
    fill: "url(#paint0_radial_78_5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 120.5,
    r: 12.5,
    fill: "url(#paint1_radial_78_5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 129.5,
    r: 5.5,
    fill: "url(#paint2_radial_78_5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 100.5,
    r: 7.5,
    fill: "url(#paint3_radial_78_5)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 110,
    r: 9,
    fill: "url(#paint4_radial_78_5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 96.5,
    r: 4.5,
    fill: "url(#paint5_radial_78_5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 33.5C279.5 42.5327 274.036 50.7705 265.077 56.7727C256.122 62.7727 243.722 66.5 230 66.5C216.278 66.5 203.878 62.7727 194.923 56.7727C185.964 50.7705 180.5 42.5327 180.5 33.5C180.5 24.4673 185.964 16.2295 194.923 10.2273C203.878 4.2273 216.278 0.5 230 0.5C243.722 0.5 256.122 4.2273 265.077 10.2273C274.036 16.2295 279.5 24.4673 279.5 33.5Z",
    fill: "white",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200.367,
    y1: 54.3391,
    x2: 188.367,
    y2: 67.3391,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.073 25.784H228.353V40.248H227.073V25.784ZM221.073 31.304H224.705V32.392H221.073V31.304ZM224.161 26.12H225.425V39.512H224.161V26.12ZM216.609 35.656H217.537C219.793 35.656 221.153 35.592 222.753 35.256L222.881 36.36C221.233 36.712 219.841 36.776 217.537 36.776H216.609V35.656ZM216.609 27.544H222.049V28.632H217.921V36.088H216.609V27.544ZM241.712 25.784H242.976V35.944H241.712V25.784ZM237.488 30.264H239.68V31.352H237.488V30.264ZM239.072 26.008H240.336V34.84H239.072V26.008ZM230.72 27.576H237.888V28.632H230.72V27.576ZM234.288 29.368C236.048 29.368 237.296 30.424 237.296 31.992C237.296 33.576 236.048 34.632 234.288 34.632C232.544 34.632 231.296 33.576 231.296 31.992C231.296 30.424 232.544 29.368 234.288 29.368ZM234.288 30.392C233.216 30.392 232.48 31.032 232.48 31.992C232.48 32.952 233.216 33.608 234.288 33.608C235.392 33.608 236.112 32.952 236.112 31.992C236.112 31.032 235.392 30.392 234.288 30.392ZM233.632 25.912H234.96V28.296H233.632V25.912ZM237.52 35.336H238.64V35.688C238.64 38.12 235.984 39.768 233.024 40.2L232.56 39.16C235.136 38.84 237.52 37.432 237.52 35.688V35.336ZM237.696 35.336H238.832V35.688C238.832 37.432 241.216 38.84 243.792 39.16L243.328 40.2C240.368 39.768 237.696 38.12 237.696 35.688V35.336Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 166,
    width: 283,
    height: 17,
    rx: 8.5,
    fill: "#FBDADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 166,
    width: 99,
    height: 17,
    rx: 8.5,
    fill: "#ED6369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.487 49.9795H126.513V80.3865H148.487V49.9795Z",
    fill: "#FFFAED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 64H103V128H170V64Z",
    fill: "#FFFAED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164 52H111V129H164V52Z",
    fill: "#FFFAED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.074 62.4395H154.015V78.9057H166.074V62.4395Z",
    fill: "#EB6262"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 67.9668H159.197V85.5994H170.4V67.9668Z",
    fill: "#EB6262"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121 62H105V79H121V62Z",
    fill: "#EB6262"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64H103V85H116V64Z",
    fill: "#EB6262"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.311 84.4736H104.601V90.0063H110.311V84.4736Z",
    fill: "#EB6262"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.405 85.0825H164.694V128.609H170.405V85.0825Z",
    fill: "#EB6262"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170 112H159V133H170V112Z",
    fill: "#EB6262"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170 118H154V129H170V118Z",
    fill: "#EB6262"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169 124H148V129H169V124Z",
    fill: "#EB6262"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110 112H100V129H110V112Z",
    fill: "#EB6262"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116 118H103V129H116V118Z",
    fill: "#EB6262"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121 123H103V129H121V123Z",
    fill: "#EB6262"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.695 67.9668H131.985V73.3727H137.695V67.9668Z",
    fill: "#EB6262"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.014 67.9668H143V73.3727H154.014V67.9668Z",
    fill: "#EB6262"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105 68H100V130H105V68Z",
    fill: "#E03E4C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175 68H169V129H175V68Z",
    fill: "#E03E4C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.405 128.604H104.601V134.009H170.405V128.604Z",
    fill: "#E03E4C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M158.564 51.3384H147.549V56.9877H158.564V51.3384Z",
    fill: "#E03E4C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.294 51.4653H116.279V56.8712H127.294V51.4653Z",
    fill: "#E03E4C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120 51H111V57H120V51Z",
    fill: "#E03E4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.887 56.8662H107.379V62.4395H112.887V56.8662Z",
    fill: "#E03E4C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62H103V68H108V62Z",
    fill: "#E03E4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164 51H155V57H164V51Z",
    fill: "#E03E4C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.874 56.9878H162.367V62.4394H167.874V56.9878Z",
    fill: "#E03E4C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M171.581 62.4595H166.074V67.9668H171.581V62.4595Z",
    fill: "#E03E4C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M159 46H116V52H159V46Z",
    fill: "#E03E4C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M130.743 94.1548H117.05V96.8577H130.743V94.1548Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.828 94.1548H139.135V96.8577H152.828V94.1548Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.686 101.599H127.994V104.302H141.686V101.599Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M125.321 100.144H116.817V102.847H125.321V100.144Z",
    fill: "#F4A688"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.097 100.144H144.592V102.847H153.097V100.144Z",
    fill: "#F4A688"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.985 67.9668H121.274V73.3727H131.985V67.9668Z",
    fill: "#FEF1D5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143 67.9668H137.695V73.3727H143V67.9668Z",
    fill: "#FEF1D5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.24 87.24) rotate(92.3859) scale(5.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70 121) rotate(92.3859) scale(12.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.72 129.72) rotate(92.3859) scale(5.28458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.8 100.8) rotate(92.3859) scale(7.20625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.36 110.36) rotate(92.3859) scale(8.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.68 96.68) rotate(92.3859) scale(4.32375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTastePink);
export default __webpack_public_path__ + "static/media/Taste_Pink.9dba82da0b58bc0563c403aae7436689.svg";
export { ForwardRef as ReactComponent };